<template>
  <v-card class="ma-0 pa-0" width="250" min-height="30" rounded="lg">
    <div class="ma-0 pa-0 pt-2 pl-2" style="background-color: #c3c3c3">
      <p class="ml-1 caption-11">
        Uploading Asset<v-icon
          v-if="!uploadingAssets"
          class="ml-3"
          size="22"
          color="primary"
          @click="uploadingAssets = !uploadingAssets"
          >mdi-menu-right</v-icon
        >
        <v-icon
          v-if="uploadingAssets"
          class="ml-3"
          size="22"
          color="primary"
          @click="uploadingAssets = !uploadingAssets"
          >mdi-menu-down</v-icon
        >
        <v-icon
          class="ml-3"
          size="22"
          color="primary"
          @click="removeUploadAsset()"
          >mdi-close</v-icon
        >
      </p>
    </div>
    <div class="ma-0 pa-0 pl-2" style="display: flex">
      <div class="ma-0 pa-0">
        <p class="ml-1 caption-11">Uploading Asset</p>
      </div>
      <v-spacer></v-spacer>
      <div class="ma-0 pa-0 mr-2">
        <p>{{ uploadPercentage }}<v-icon>mdi-circle-outline</v-icon></p>
      </div>
    </div>
  </v-card>
</template>

<script>
import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import { mapState } from "vuex";

export default {
  name: "processManagerUpload",

  components: {},

  data: function () {
    return {
      uploadingAssets: false,
      uploadPercentage: 0,
    };
  },
  props: {
    assetFormData: Object,
  },

  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    ...mapState(["augmentableTheme"]),
  },

  mounted() {
    var formData = this.$store.state.uploadAssetFormData;

    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ", " + pair[1]);
    // }

    this.$vuetify.theme.dark = this.augmentableTheme;

    this.uploadAsset(formData);
  },

  methods: {
    uploadAsset(formData) {
      for (var pair of formData.entries()) {
        console.log(pair[0] + ", " + pair[1]);
      }
      axios
        .post(this.$abServerPath + "/api/glbfiles/glbpostfile/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          }.bind(this),
        })
        .then((response) => {
          console.log(response.data);
          if (response.data.error) {
            console.log(response.data.error);
          }
          console.log("SUCCESS!!");
          this.$root.$emit("glbAssetsGetAllfiles");
          this.$store.commit("setActivateshowUpload", false);
        })
        .catch((error) => {
          console.log(error);
          console.log("ffff");
          this.$root.$emit("glbAssetsGetAllfiles");
          this.$store.commit("setActivateshowUpload", false);
        });
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    removeUploadAsset() {
      this.$store.commit("setActivateshowUpload", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:200,300,400,600,700,800,900");
@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");
</style>


